import { render, staticRenderFns } from "./UploadMult.vue?vue&type=template&id=3a87f504&scoped=true&"
import script from "./UploadMult.vue?vue&type=script&lang=js&"
export * from "./UploadMult.vue?vue&type=script&lang=js&"
import style0 from "./UploadMult.vue?vue&type=style&index=0&id=3a87f504&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87f504",
  null
  
)

export default component.exports